// import React, { useState, useEffect } from "react";
// import {
//   FaChartLine,
//   FaHandshake,
//   FaUsers,
//   FaBriefcase,
//   FaUserCog,
//   FaFileInvoice,
//   FaCog,
//   FaChevronDown,
//   FaChevronRight,
//   FaBars,
  
// } from "react-icons/fa";
// import { Link, useLocation } from "react-router-dom";

// // ── Resolve the actual functional role ───────────────────────────────────────
// const resolveEffectiveRole = () => {
//   const loginType = localStorage.getItem("loginType");

//   try {
//     const raw = localStorage.getItem("userProfile");
//     if (raw) {
//       const profile = JSON.parse(raw);
//       const profileRole =
//         profile.role || (Array.isArray(profile.roles) ? profile.roles[0] : null);
//       if (profileRole) {
//         return {
//           role: String(profileRole).toUpperCase().trim().replace(/^ROLE_/, ""),
//           isEmployee: loginType === "employee",
//         };
//       }
//     }
//   } catch { /* ignore */ }

//   const raw = localStorage.getItem("userRole") || "";
//   try {
//     const parsed = JSON.parse(raw);
//     const r = Array.isArray(parsed) ? parsed[0] : parsed;
//     return {
//       role: String(r).toUpperCase().trim().replace(/^ROLE_/, ""),
//       isEmployee: loginType === "employee",
//     };
//   } catch {
//     const r = raw.replace(/^["[]+|["\]]+$/g, "").toUpperCase().trim().replace(/^ROLE_/, "");
//     return { role: r, isEmployee: loginType === "employee" };
//   }
// };

// const Sidebar = ({ setIsAuthenticated }) => {
//   const [isExpanded, setIsExpanded] = useState(() => {
//     const saved = localStorage.getItem("sidebarExpanded");
//     return saved !== null ? JSON.parse(saved) : true;
//   });
//   const location = useLocation();
//   const activeView = location.pathname.slice(1) || "home";

//   const { role: effectiveRole, isEmployee } = resolveEffectiveRole();

//   const isSuperAdmin     = effectiveRole === "SUPERADMIN";
//   const canAccessCRM     = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "CRM" || (!isEmployee && effectiveRole !== "ATS" && effectiveRole !== "INVOICE"));
//   const canAccessATS     = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "ATS");
//   const canAccessInvoice = !isSuperAdmin && (effectiveRole === "ADMIN" || effectiveRole === "INVOICE");
//   const canAccessAdmin   = !isSuperAdmin && (effectiveRole === "ADMIN" && !isEmployee);

//   useEffect(() => {
//     localStorage.setItem("sidebarExpanded", JSON.stringify(isExpanded));
//     if (isExpanded) {
//       document.body.classList.remove("sidebar-collapsed");
//       document.body.classList.add("sidebar-expanded");
//     } else {
//       document.body.classList.remove("sidebar-expanded");
//       document.body.classList.add("sidebar-collapsed");
//     }
//   }, [isExpanded]);

//   // ── Menu definition ───────────────────────────────────────────────────────
//   const menuItems = [
//     ...(isSuperAdmin
//       ? [
//           {
//             name: "Dashboard",
//             icon: <FaChartLine />,
//             subItems: [{ path: "superadmin/dashboard", label: "Statistics" }],
//           },
//           {
//             name: "User Management",
//             icon: <FaUserCog />,
//             subItems: [{ path: "superadmin/users", label: "All Users" }],
//           },
//         ]
//       : []),

//     ...(canAccessCRM
//       ? [
//           {
//             name: "Sales Management",
//             icon: <FaChartLine />,
//             subItems: [
//               { path: "company",  label: "Company" },
//               { path: "contacts", label: "Contacts" },
//               { path: "tasks",    label: "Tasks" },
//             ],
//           },
//           {
//             name: "Client Management",
//             icon: <FaHandshake />,
//             subItems: [{ path: "clients", label: "Clients" }],
//           },
//         ]
//       : []),

//     ...(canAccessATS
//       ? [
//           {
//             name: "Job Postings",
//             icon: <FaBriefcase />,
//             subItems: [{ path: "ats/jobs", label: "Job Postings" }],
//           },
//           {
//             name: "Candidates",
//             icon: <FaUsers />,
//             subItems: [
//               { path: "ats/all-candidates",   label: "All Candidates" },
//               { path: "ats/candidatesharing", label: "Shortlisted" },
//             ],
//           },
//           ...(!canAccessCRM
//             ? [
//                 {
//                   name: "Client Management",
//                   icon: <FaHandshake />,
//                   subItems: [{ path: "clients", label: "Clients" }],
//                 },
//               ]
//             : []),
//         ]
//       : []),

//     ...(canAccessInvoice
//       ? [
//           {
//             name: "Invoice Management",
//             icon: <FaFileInvoice />,
//             subItems: [
//               { path: "invoice",         label: "Invoice" },
//               { path: "generic-invoice", label: "Generic Invoice" },
//               { path: "items",           label: "Items" },
//             ],
//           },
//         ]
//       : []),

//     ...(canAccessAdmin
//       ? [
//           {
//             name: "Business Analytics",
//             icon: <FaChartLine />,
//             subItems: [
//               { path: "admin/dashboard", label: "Dashboard" },
//               { path: "admin/reports",   label: "Reports" },
//             ],
//           },
//           {
//             name: "Users Management",
//             icon: <FaUserCog />,
//             subItems: [{ path: "admin/users", label: "User Management" }],
//           },
//           {
//             name: "My Services",
//             icon: <FaCog />,
//             subItems: [{ path: "admin/profile", label: "Profile" }],
//           },
//         ]
//       : []),
//   ];

//   // ── Helpers ───────────────────────────────────────────────────────────────


//   const isMenuActive = (item) => {
//     const normalize = (p) => p.replace(/^\//, "").toLowerCase();
//     if (item.subItems) {
//       return item.subItems.some((sub) => {
//         const subPath = normalize(sub.path);
//         return (
//           normalize(activeView) === subPath ||
//           normalize(activeView).startsWith(subPath) ||
//           subPath.startsWith(normalize(activeView))
//         );
//       });
//     }
//     return normalize(activeView) === item.name.toLowerCase().replace(/\s+/g, "-");
//   };

//   // ── Role badge ────────────────────────────────────────────────────────────
//   const roleBadgeStyle = {
//     SUPERADMIN: "bg-red-100 text-red-700 border border-red-200",
//     ADMIN:      "bg-orange-100 text-orange-700",
//     ATS:        "bg-purple-100 text-purple-700",
//     CRM:        "bg-green-100 text-green-700",
//     INVOICE:    "bg-yellow-100 text-yellow-700",
//   };
//   const roleBadgeCls = roleBadgeStyle[effectiveRole] || "bg-blue-100 text-blue-700";
//   const roleIcon     = isSuperAdmin ? "🛡️" : isEmployee ? "👤" : "🏢";
//   const roleLabel    = isSuperAdmin ? "Super Admin" : effectiveRole;

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <div
//   className={`fixed top-0 left-0 h-screen border-r shadow-lg flex flex-col transition-all duration-300 ease-in-out z-30 ${
//     isExpanded ? "w-64" : "w-20"
//   }`}
//   style={{ backgroundColor: "#1C4E6D" }}
// >
//       {/* ── Header — Dark Teal-Blue style for ALL roles ── */}
//       <div className="flex items-center justify-between border-b px-5 py-4" style={{ borderBottomColor: "rgba(255,255,255,0.1)" }}>
//         <div className="flex items-center">
//           <div className="text-white font-bold rounded-full flex items-center justify-center w-10 h-10 mr-2 shadow-md" style={{ backgroundColor: "#1C4E6D" }}>
//             ATS
//           </div>
//           {isExpanded && (
//             <span className="text-lg font-semibold text-white whitespace-nowrap">
//               CIRCLE
//             </span>
//           )}
//         </div>
//         <button
//           onClick={() => setIsExpanded(!isExpanded)}
//           className="text-white hover:text-gray-200 transition-colors p-1"
//           title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
//         >
//           <FaBars size={18} />
//         </button>
//       </div>

//       {/* ── Role badge ── */}
//       {isExpanded && (
//         <div className="px-4 py-2 border-b" style={{ backgroundColor: "rgba(255,255,255,0.1)", borderBottomColor: "rgba(255,255,255,0.1)" }}>
//           <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${roleBadgeCls}`}>
//             <span>{roleIcon}</span>
//             <span>{roleLabel}</span>
//           </span>
//         </div>
//       )}

//       {/* ── Navigation — Dark Teal-Blue active style for ALL roles ── */}
//       <div className="flex-1 overflow-y-auto custom-scrollbar">
//         <ul className="py-3 space-y-1">
//           {menuItems.map((item) => (
//             <li key={item.name}>
//               <div
//                 className={`flex items-center justify-between px-4 py-2.5 mx-2 rounded-lg transition-all duration-200 ${
//                   isMenuActive(item)
//                     ? "text-white shadow-md"
//                     : "text-gray-300 hover:text-white"
//                 }`}
//                 style={isMenuActive(item) ? { backgroundColor: "rgba(255,255,255,0.15)" } : {}}
//               >
//                 <span
//                   className={`flex items-center ${
//                     isExpanded ? "gap-3" : "justify-center w-full"
//                   }`}
//                 >
//                   <span
//                     className="text-lg"
//                     title={!isExpanded ? item.name : ""}
//                   >
//                     {item.icon}
//                   </span>
//                   {isExpanded && (
//                     <span className="text-sm font-medium whitespace-nowrap">
//                       {item.name}
//                     </span>
//                   )}
//                 </span>
//               </div>

//               {/* Submenu - Always visible and static */}
//               {item.subItems && isExpanded && (
//                 <ul className="ml-8">
//                   {item.subItems.map((sub) => {
//                     const subPath = sub.path.toLowerCase();
//                     const isActive =
//                       activeView === subPath || activeView.startsWith(subPath);
//                     return (
//                       <li key={subPath}>
//                         <Link
//                           to={`/${subPath}`}
//                           className={`block px-3 py-2 text-sm rounded-md transition-all duration-150 ${
//                             isActive
//                               ? "text-white font-medium"
//                               : "text-gray-300 hover:text-white"
//                           }`}
//                           style={isActive ? { backgroundColor: "rgba(255,255,255,0.15)" } : {}}
//                         >
//                           • {sub.label}
//                         </Link>
//                       </li>
//                     );
//                   })}
//                 </ul>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* ── Footer — Dark Teal-Blue logout for ALL roles ── */}
//       <div className="border-t p-4" style={{ borderTopColor: "rgba(255,255,255,0.1)" }}>
//         <button
//           onClick={() => {
//             localStorage.removeItem("isAuthenticated");
//             localStorage.removeItem("token");
//             localStorage.removeItem("userRole");
//             localStorage.removeItem("userProfile");
//             localStorage.removeItem("loginType");
//             localStorage.removeItem("userId");
//             localStorage.removeItem("email");
            
//             setIsAuthenticated(false);
//           }}
//           className={`w-full text-white py-2 rounded-lg font-semibold transition-all duration-200 shadow-sm hover:shadow-md ${
//             !isExpanded ? "text-xs px-2" : ""
//           }`}
//           style={{
//             backgroundColor: "rgba(255,255,255,0.15)",
//           }}
//           onMouseEnter={(e) => e.target.style.backgroundColor = "rgba(255,255,255,0.25)"}
//           onMouseLeave={(e) => e.target.style.backgroundColor = "rgba(255,255,255,0.15)"}
//           title={!isExpanded ? "Logout" : ""}
//         >
//           {isExpanded ? "Logout" : "Out"}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import {
  FaChartLine,
  FaHandshake,
  FaUsers,
  FaBriefcase,
  FaUserCog,
  FaFileInvoice,
  FaCog,
  FaBars,
  FaChevronDown,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import { authAPI } from "../../services/api";

const resolveEffectiveRole = () => {
  const loginType = localStorage.getItem("loginType");

  try {
    const raw = localStorage.getItem("userProfile");
    if (raw) {
      const profile = JSON.parse(raw);
      let profileRoles = [];
      if (Array.isArray(profile.roles) && profile.roles.length) {
        profileRoles = profile.roles.map(r => String(r).toUpperCase().trim().replace(/^ROLE_/, ""));
      } else if (profile.role) {
        profileRoles = [String(profile.role).toUpperCase().trim().replace(/^ROLE_/, "")];
      }
      if (profileRoles.length) {
        return {
          roles: profileRoles,
          isEmployee: loginType === "employee",
          orgType: profile.organizationType || profile.orgType || "",
        };
      }
    }
  } catch {}

  const raw = localStorage.getItem("userRole") || "";
  try {
    const parsed = JSON.parse(raw);
    const arr = Array.isArray(parsed) ? parsed : [parsed];
    return {
      roles: arr.map(r => String(r).toUpperCase().trim().replace(/^ROLE_/, "")),
      isEmployee: loginType === "employee",
      orgType: "",
    };
  } catch {
    const r = raw.replace(/^["[]+|["\]]+$/g, "").toUpperCase().trim().replace(/^ROLE_/, "");
    return { roles: r ? [r] : [], isEmployee: loginType === "employee", orgType: "" };
  }
};

const Sidebar = ({ setIsAuthenticated }) => {
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem("sidebarExpanded");
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [openMenus, setOpenMenus] = useState(() => new Set());

  const location = useLocation();
  const activeView = location.pathname.slice(1) || "home";

  const { roles: effectiveRoles, isEmployee, orgType } = resolveEffectiveRole();
  const primaryRole = effectiveRoles[0] || "";

  const orgTypeUpper = String(orgType).toUpperCase().trim();
  const isCorporate  = orgTypeUpper === "CORPORATE";
  const isStaffing   = orgTypeUpper === "STAFFING_AGENCY";
  const isFreelancer = orgTypeUpper === "FREELANCER";

  const isSuperAdmin = effectiveRoles.includes("SUPERADMIN");

  // ── Access flags ──────────────────────────────────────────────────────────

  const canAccessCRM = !isSuperAdmin && (
    isFreelancer ||
    effectiveRoles.includes("ADMIN") ||
    effectiveRoles.includes("CRM")
  );

  const canAccessATS = !isSuperAdmin && (
    isFreelancer ||
    effectiveRoles.includes("ADMIN") ||
    effectiveRoles.includes("ATS")
  );

  const canAccessInvoice = !isSuperAdmin && (
    isFreelancer ||
    effectiveRoles.includes("ADMIN") ||
    effectiveRoles.includes("INVOICE")
  );

  // Business Analytics → Freelancer always + Corporate/Staffing ADMIN only
  const canAccessBusinessAnalytics = !isSuperAdmin && (
    isFreelancer ||
    ((isCorporate || isStaffing) && effectiveRoles.includes("ADMIN"))
  );

  // Users Management → Corporate/Staffing ADMIN only
  const canAccessUserMgmt = !isSuperAdmin && !isFreelancer && (
    (isCorporate || isStaffing) && effectiveRoles.includes("ADMIN")
  );

  // My Services → all org types + employees (employees see Profile only)
  const canAccessMyServices = !isSuperAdmin && (
    isEmployee || isFreelancer || isCorporate || isStaffing
  );

  useEffect(() => {
    localStorage.setItem("sidebarExpanded", JSON.stringify(isExpanded));
    if (isExpanded) {
      document.body.classList.remove("sidebar-collapsed");
      document.body.classList.add("sidebar-expanded");
    } else {
      document.body.classList.remove("sidebar-expanded");
      document.body.classList.add("sidebar-collapsed");
    }
  }, [isExpanded]);

  // ── Menu ──────────────────────────────────────────────────────────────────
  const menuItems = [
    // SuperAdmin menu
    ...(isSuperAdmin
      ? [
          {
            name: "Dashboard",
            icon: <FaChartLine />,
            subItems: [{ path: "superadmin/dashboard", label: "Statistics" }],
          },
          {
            name: "User Management",
            icon: <FaUserCog />,
            subItems: [{ path: "superadmin/users", label: "All Users" }],
          },
        ]
      : []),

    // CRM
    ...(canAccessCRM
      ? [
          {
            name: "Sales Management",
            icon: <FaChartLine />,
            subItems: [
              { path: "company",  label: "Company" },
              { path: "contacts", label: "Contacts" },
              { path: "tasks",    label: "Tasks" },
            ],
          },
          {
            name: "Client Management",
            icon: <FaHandshake />,
            subItems: [{ path: "clients", label: "Clients" }],
          },
        ]
      : []),

    // ATS
    ...(canAccessATS
      ? [
          {
            name: "Job Postings",
            icon: <FaBriefcase />,
            subItems: [{ path: "ats/jobs", label: "Job Postings" }],
          },
          {
            name: "Candidates",
            icon: <FaUsers />,
            subItems: [
              { path: "ats/all-candidates", label: "All Candidates" },
            ],
          },
          ...(!canAccessCRM
            ? [
                {
                  name: "Client Management",
                  icon: <FaHandshake />,
                  subItems: [{ path: "clients", label: "Clients" }],
                },
              ]
            : []),
        ]
      : []),

    // Invoice
    ...(canAccessInvoice
      ? [
          {
            name: "Invoice Management",
            icon: <FaFileInvoice />,
            subItems: [
              { path: "invoice",         label: "Invoice" },
              { path: "generic-invoice", label: "Generic Invoice" },
              { path: "items",           label: "Items" },
            ],
          },
        ]
      : []),

    // Business Analytics → Freelancer + Corporate/Staffing ADMIN
    ...(canAccessBusinessAnalytics
      ? [
          {
            name: "Business Analytics",
            icon: <FaChartLine />,
            subItems: [
              { path: "dashboard",     label: "Dashboard" },
              { path: "admin/reports", label: "Reports" },
            ],
          },
        ]
      : []),

    // Users Management → Corporate/Staffing ADMIN only
    ...(canAccessUserMgmt
      ? [
          {
            name: "Users Management",
            icon: <FaUserCog />,
            subItems: [{ path: "admin/users", label: "User Management" }],
          },
        ]
      : []),

    // My Services → Freelancer + Corporate + Staffing (all roles)
    ...(canAccessMyServices
      ? [
          {
            name: "My Services",
            icon: <FaCog />,
            subItems: [
              { path: "admin/profile", label: "Profile" },
              ...(canAccessBusinessAnalytics && !isEmployee
                ? [
                    { path: "settings/templates", label: "Templates" },
                    { path: "settings/integrations", label: "Integrations" },
                    { path: "settings/fields", label: "Fix Fields" },
                  ]
                : []),
            ],
          },
        ]
      : []),
  ];

  // ── Active check ──────────────────────────────────────────────────────────
  const isMenuActive = (item) => {
    const normalize = (p) => p.replace(/^\//, "").toLowerCase();
    if (item.subItems) {
      return item.subItems.some((sub) => {
        const subPath = normalize(sub.path);
        return (
          normalize(activeView) === subPath ||
          normalize(activeView).startsWith(subPath) ||
          subPath.startsWith(normalize(activeView))
        );
      });
    }
    return normalize(activeView) === item.name.toLowerCase().replace(/\s+/g, "-");
  };

  // Auto-open the section that contains the active route
  useEffect(() => {
    const active = menuItems.find((item) => isMenuActive(item));
    if (active) setOpenMenus(new Set([active.name]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => {
      if (prev.has(menuName)) return new Set();
      return new Set([menuName]);
    });
  };

  // ── Role badge ────────────────────────────────────────────────────────────
  const roleBadgeStyle = {
    SUPERADMIN:      "bg-red-100 text-red-700 border border-red-200",
    ADMIN:           "bg-orange-100 text-orange-700",
    ATS:             "bg-purple-100 text-purple-700",
    CRM:             "bg-green-100 text-green-700",
    INVOICE:         "bg-yellow-100 text-yellow-700",
    USER_MANAGEMENT: "bg-blue-100 text-blue-700",
  };
  const roleBadgeCls = roleBadgeStyle[primaryRole] || "bg-blue-100 text-blue-700";
  const roleIcon     = isSuperAdmin ? "🛡️" : isEmployee ? "👤" : "🏢";
  const roleLabel    = isSuperAdmin
    ? "Super Admin"
    : orgTypeUpper
    ? orgTypeUpper.replace("_", " ")
    : effectiveRoles.join(", ");

  // ── Render ────────────────────────────────────────────────────────────────
  return (
    <div
      className={`fixed top-0 left-0 h-screen border-r shadow-lg flex flex-col transition-all duration-300 ease-in-out z-30 bg-white ${
        isExpanded ? "w-64" : "w-20"
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
        <div className="flex items-center overflow-hidden">
          <img
            src="/clustrops-logo.png"
            alt="ClustrOps Logo"
            className="h-12 max-w-[200px] object-contain transition-all duration-300"
            style={!isExpanded ? { maxWidth: "40px", objectPosition: "left" } : {}}
          />
        </div>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-gray-500 hover:text-[#1C4E6D] transition-colors p-1"
          title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
        >
          <FaBars size={18} />
        </button>
      </div>

      {/* Role Badge */}
      {isExpanded && (
        <div className="px-4 py-2 border-b border-gray-200 bg-gray-50">
          <span
            className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${roleBadgeCls}`}
          >
            <span>{roleIcon}</span>
            <span>{roleLabel}</span>
          </span>
        </div>
      )}

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <ul className="py-3 space-y-1">
          {menuItems.map((item) => {
            const isActive = isMenuActive(item);
            const isOpen = openMenus.has(item.name);
            return (
              <li key={item.name}>
                <div
                  onClick={() => isExpanded && toggleMenu(item.name)}
                  className={`flex items-center justify-between px-4 py-2.5 mx-2 rounded-lg transition-all duration-200 cursor-pointer ${
                    isActive
                      ? "bg-[#1C4E6D] text-white shadow-md"
                      : "text-gray-600 hover:bg-gray-100 hover:text-[#1C4E6D]"
                  }`}
                >
                  <span
                    className={`flex items-center ${
                      isExpanded ? "gap-3" : "justify-center w-full"
                    }`}
                  >
                    <span className="text-lg" title={!isExpanded ? item.name : ""}>
                      {item.icon}
                    </span>
                    {isExpanded && (
                      <span className="text-sm font-medium whitespace-nowrap">
                        {item.name}
                      </span>
                    )}
                  </span>
                  {isExpanded && item.subItems && (
                    <FaChevronDown
                      size={11}
                      className={`flex-shrink-0 transition-transform duration-200 ${
                        isOpen ? "rotate-180" : ""
                      } ${isActive ? "text-white" : "text-gray-400"}`}
                    />
                  )}
                </div>

                {/* Accordion submenu */}
                {item.subItems && isExpanded && (
                  <ul
                    className={`overflow-hidden transition-all duration-200 ease-in-out ml-8 space-y-1 ${
                      isOpen ? "max-h-60 mt-1" : "max-h-0"
                    }`}
                  >
                    {item.subItems.map((sub) => {
                      const subPath = sub.path.toLowerCase();
                      const isSubActive =
                        activeView === subPath || activeView.startsWith(subPath);
                      return (
                        <li key={subPath}>
                          <Link
                            to={`/${subPath}`}
                            className={`block px-3 py-2 text-sm rounded-md transition-all duration-150 ${
                              isSubActive
                                ? "text-[#1C4E6D] font-bold"
                                : "text-gray-500 hover:text-[#1C4E6D] hover:bg-gray-50"
                            }`}
                            style={
                              isSubActive
                                ? { backgroundColor: "rgba(28, 78, 109, 0.1)" }
                                : {}
                            }
                          >
                            • {sub.label}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      {/* Logout */}
      <div className="border-t border-gray-200 p-4">
        <button
          onClick={async () => {
            // B1-15: revoke this account's tokens on the backend before clearing local state.
            // A failed/slow backend call must never block the local logout.
            try {
              await authAPI.logout();
            } catch (err) {
              console.error("Logout API call failed:", err);
            }
            localStorage.removeItem("isAuthenticated");
            localStorage.removeItem("token");
            localStorage.removeItem("userRole");
            localStorage.removeItem("userProfile");
            localStorage.removeItem("loginType");
            localStorage.removeItem("userId");
            localStorage.removeItem("email");
            setIsAuthenticated(false);
          }}
          className={`w-full py-2 rounded-lg font-semibold transition-all duration-200 shadow-sm hover:shadow-md bg-[#1C4E6D] text-white hover:bg-[#153b52] ${
            !isExpanded ? "text-xs px-2" : ""
          }`}
          title={!isExpanded ? "Logout" : ""}
        >
          {isExpanded ? "Logout" : "Out"}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;